import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { type Session, sessionQueryOptions } from '@/entities/session'
import { ToastViewport } from '@/shared/ui/toast'

export interface RouterContext {
  queryClient: QueryClient
  session: Session | null
}

// Корневой beforeLoad — единственная точка загрузки session: гейты дочерних
// роутов читают её из context без хуков. 401 у /auth/me → session null (не падение).
export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions)
    return { session }
  },
  // Fallback-тайтл; разделы уточняют через head: на своих роутах.
  head: () => ({ meta: [{ title: 'STIT Deal' }] }),
  component: RootLayout,
})

function RootLayout() {
  return (
    <>
      <HeadContent />
      <Outlet />
      <ToastViewport />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  )
}
